import { Container, Marca }  from './styles';
import marca from '../../assets/metodo-billings-logo-dashboard.png'
import { Link } from 'react-router-dom';

export function Aside(){
    return(
        <Container>
            <Marca><Link to="/dashboard"><img src={marca} alt="Método Billings" /></Link></Marca>
            {/*
            <Buttons>
                <button><span className="material-icons">chevron_right</span></button>
                <button><span className="material-icons">chevron_left</span></button>
            </Buttons>
            */}

            <div className="bottom icoChat">
                <a href="https://api.whatsapp.com/send?phone=5533988017451&amp;amp;amp;text=Ol%C3%A1%20gostaria%20de%20falar%20sobre%20o%20APP%20Mob" target="_blank" rel="noreferrer">
                <span title="FALE COM O DESENVOLVEDOR" className="material-icons">wechat</span>                
                </a>
            </div>
        </Container>
    )
}
